const AboutSection = () => {
  return (
    <section id="about" className="py-24 lg:py-32 bg-gradient-to-br from-amber-50 to-orange-50">
      <div className="max-w-7xl mx-auto px-6 lg:px-12">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          <div className="space-y-8">
            <div className="inline-block">
              <span className="text-xs uppercase tracking-wider bg-black/5 px-5 py-2 rounded-full text-gray-700 font-medium whitespace-nowrap">
                About CANDOR
              </span>
            </div>
            <h2 className="font-['Inter'] font-bold text-5xl lg:text-6xl text-gray-900 leading-tight">
              Expert Team<br />
              Building Premium<br />
              iOS Solutions
            </h2>
            <p className="text-gray-600 text-base leading-relaxed max-w-md">
              At CANDOR d.o.o., we specialize in developing cutting-edge iOS applications that prioritize user experience, security, and performance. Our team of dedicated experts combines technical excellence with innovative design to create applications that truly make a difference in users' daily lives. From VPN solutions that protect your privacy to Cleaner apps that optimize your device, we're committed to delivering premium quality mobile experiences.
            </p>
          </div>

          <div className="flex justify-center lg:justify-end">
            <div className="relative">
              <div className="w-full h-[500px] rounded-3xl overflow-hidden shadow-2xl">
                <img
                  src="https://public.readdy.ai/ai/img_res/64f6c4e4f9fad62e237e66bda458f6cf.jpg"
                  alt="CANDOR Team"
                  className="w-full h-full object-cover"
                />
              </div>
              <div className="absolute -bottom-6 -right-6 w-32 h-32 bg-gradient-to-br from-cyan-400 to-blue-500 rounded-3xl opacity-20 blur-2xl"></div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutSection;
